import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FadeUp, SectionHeader } from "./Reveal";
import { FAQS, CONTACT } from "../../lib/content";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative py-32 md:py-48">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16">
        <div className="md:col-span-5">
          <SectionHeader number="05" kicker="Good to know">
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-[#1c1610]">
              <FadeUp>Questions, <em className="italic text-[#DB0909]">answered.</em></FadeUp>
            </h2>
          </SectionHeader>
          <FadeUp delay={0.1} className="mt-8 max-w-sm">
            <p className="text-[#4a3e30] font-light leading-relaxed">
              The things students usually ask before their first class. Anything else?{" "}
              <a
                data-testid="faq-whatsapp-link"
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#950606] underline underline-offset-4 hover:text-[#DB0909] transition-colors duration-300 inline-block py-2 -my-2 px-1"
              >
                Ask on WhatsApp
              </a>
              .
            </p>
          </FadeUp>
        </div>

        <FadeUp delay={0.15} className="md:col-span-7">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                className="border-b border-[rgba(28,22,16,0.14)]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left hover:no-underline group"
                >
                  <span className="flex items-baseline gap-5">
                    <span className="font-mono text-[11px] text-[#950606]">{String(i + 1).padStart(2, "0")}</span>
                    <span className="font-display font-bold text-lg md:text-xl text-[#1c1610] group-hover:text-[#950606] transition-colors duration-300">
                      {f.q}
                    </span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 pl-10">
                  <p className="text-[#4a3e30] font-light leading-relaxed text-base">{f.a}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </div>
  </section>
);
